import { render, staticRenderFns } from "./AvatarGroupCard.vue?vue&type=template&id=ad218f7e&scoped=true&"
import script from "./AvatarGroupCard.vue?vue&type=script&lang=js&"
export * from "./AvatarGroupCard.vue?vue&type=script&lang=js&"
import style0 from "./AvatarGroupCard.vue?vue&type=style&index=0&id=ad218f7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad218f7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VSheet,VTooltip})
